// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/g-countermeasures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/g-countermeasures/g-countermeasures.js';
import g1 from '../lessons/aeronautics/g-countermeasures/g-tolerance-factors.js';

mount([g0, g1]);
